import { FC, useContext } from "react";
import useForm from "../../hooks/useForm";
import ContractorStepNavigation from "./ContractorStepNavigation";
import ContractorHeading from "./components/Heading";
import { ContractorContext } from "./CreateContractor";
import MultiInputSpinButton from "./components/MultiInputSpinButton";
import { foreignWorkerBondValidations } from "../../helpers/contractor/validations";
import ServerError from "../errors/ServerError";
import { useTranslation } from "react-i18next";

type Props = {
  onSubmit: VoidFunction | null;
  onPrevious: VoidFunction | null;
};

const ForeignWorkerBondDetails: FC<Props> = ({ onSubmit, onPrevious }) => {
  const { t } = useTranslation("pages", { keyPrefix: "contractor.newContractor.fwbDetails" });
  const { state, setFormState, onChange, isSubmitting, submitError, setSubmitError } = useContext(ContractorContext);
  const { field, validateForm, validateField } = useForm(state, foreignWorkerBondValidations, onChange as any);
  const handleNext = () => validateForm(() => onSubmit?.());

  return (
    <div className="container-flow flex-grow">
      <ContractorHeading title={t("title")} />
      <div className="flex flex-col gap-4">
        {state.agents.map((ele, index, originalInput) => (
          <MultiInputSpinButton
            t={t}
            key={index}
            originalInput={originalInput}
            keyIndex={index}
            fieldToReplicate={"agents"}
            ele={ele}
            setState={setFormState}
            addBtnText={t("button.addAgent")}
            maxCount={3}
            validateField={validateField}
            limitMessage={t("maximumAgentAdded")}
            {...field["agents"]}
          />
        ))}
      </div>
      <ContractorStepNavigation onNext={handleNext} onBack={onPrevious} isLoading={isSubmitting} />
      {submitError && <ServerError displayType="modal" onClose={() => setSubmitError(false)} supportEmailId={t("customerSupport.emailId")} />}
    </div>
  );
};

export default ForeignWorkerBondDetails;
